import React, { useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import Select from "react-select";
import {
  CloseIcon,
  filterBlackIcon,
  FilterIcon,
} from "../../../../assets/images";
import { DropDownUserType } from "../../../Jobs/RecurringJobReport/RecurringJobReportHeader";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";
import { components } from "react-select";
import { CircularAvatar } from "../../../commons";

type DropDownOptionType = {
  value: number | null;
  label: string;
};

type AppProps = {
  setClearFilter: (data: boolean) => void;
  setOffset: React.Dispatch<React.SetStateAction<number>>;
  finalUserList: DropDownOptionType[];
  userFetching: boolean;
  setUserText: React.Dispatch<React.SetStateAction<string>>;
  setInternalUserSelected: React.Dispatch<
    React.SetStateAction<DropDownUserType>
  >;
  internalUserSelected: DropDownUserType;
  setActiveUser: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  activeUser: DropDownUserType;
  checkUserBottom: (e: any) => void;
  toggle: boolean;
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
  departmentText?: string;
  setDepartmentOffset?:
    | React.Dispatch<React.SetStateAction<number>>
    | undefined;
  setDepartmentText?: React.Dispatch<React.SetStateAction<string>>;
  finalUsersDepartmentList?: any;
  checkDepartmentBottom: (e: any) => void;
  departmentSelected: DropDownUserType;
  setDepartmentSelected: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  activeDepartment: DropDownUserType;
  setActiveDepartment: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  usersDepartmentFetching?: boolean;
  startDate: string;
  endDate: string;
};

const AvailabilityReportFilter = ({
  setClearFilter,
  setOffset,
  finalUserList,
  userFetching,
  setUserText,
  setInternalUserSelected,
  internalUserSelected,
  setActiveUser,
  activeUser,
  checkUserBottom,
  toggle,
  setToggle,
  departmentText,
  finalUsersDepartmentList,
  setDepartmentOffset,
  setDepartmentText,
  checkDepartmentBottom,
  departmentSelected,
  setDepartmentSelected,
  setActiveDepartment,
  activeDepartment,
  usersDepartmentFetching,
  startDate,
  endDate,
}: AppProps) => {
  const resetFilterData = () => {
    // setActiveStatusValue(activeStatus.toString());
    setActiveUser(internalUserSelected);
  };
  const handleSubmit = () => {
    setInternalUserSelected(activeUser);
    setActiveDepartment(departmentSelected);
    setClearFilter(false);
  };
  const onMenuClose = () => {
    // setLoadCondition(true);
    setOffset(0);
  };

  const handleUserDropDownChange = (data: any) => {
    setActiveUser({ label: data?.label, value: data?.value });
  };
  const handleDepartmentDropDownChange = (e: any) => {
    setDepartmentSelected(e);
  };

  const clearFilter = () => {
    setInternalUserSelected({ label: "Select...", value: null });
    setActiveUser({ label: "Select...", value: null });
    setDepartmentSelected({ label: "Select...", value: null });
    setActiveDepartment({ label: "Select...", value: null });
    setOffset(0);
    setClearFilter(true);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "100%",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "65%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: "150%",
      // position: 'absolute'
    }),
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(startDate?.length && endDate?.length ? !toggle : toggle);
      }}
    >
      <DropdownToggle
        caret
        color="secondary"
        style={
          toggle || internalUserSelected?.value || departmentSelected?.value
            ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
            : (!startDate?.length || !endDate?.length ) ? 
            {
                color: "#dd4433",
                border: "1px solid #bfcbe1",
                backgroundColor: "#d3d3d3	",
              }
           : { border: "1px solid#bfcbe1" }
        }
        outline
      >
        <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />
      </DropdownToggle>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <div className="mt-4 ml-1">
            <div>
              <div className="col-md-12 p-0">
                <label className="mb-1" htmlFor="">
                  User
                </label>
                <Select
                  // options={
                  //   finalUserList?.length
                  //     ? [...finalUserList]
                  //     : finalUserList
                  // }
                  // styles={dropDownStyle}
                  options={finalUserList}
                  value={activeUser}
                  components={{ Option }}
                  onChange={(e) => handleUserDropDownChange(e)}
                  isSearchable={true}
                  isLoading={userFetching}
                  onMenuClose={onMenuClose}
                  onMenuScrollToBottom={(e: any) => checkUserBottom(e)}
                  onInputChange={(e: any) => {
                    setUserText(e);
                    setOffset(0);
                  }}
                  placeholder="Select"
                />
              </div>
            </div>
            <div>
              <div className="col-md-12 p-0">
                <label className="mb-1 mt-4" htmlFor="">
                  Department
                </label>

                <Select
                  // className="dropdown"
                  options={finalUsersDepartmentList}
                  value={departmentSelected}
                  onChange={(e) => handleDepartmentDropDownChange?.(e)}
                  isSearchable={true}
                  isLoading={
                    usersDepartmentFetching && (departmentText?.length || 0) > 0
                  }
                  onMenuClose={() => setDepartmentOffset?.(0)}
                  onMenuScrollToBottom={(e: any) => checkDepartmentBottom(e)}
                  onInputChange={(e) => {
                    setDepartmentText?.(e);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AvailabilityReportFilter;
